import $ from 'jquery'
import manager from '../manager'
import Queue from '@/utils/queue'
import {getPresale} from '@/api/presale'
import {fetchTimeDiff,getZoneDiff,paddingZero} from '@/utils/timeFormat'
import translate from '@/utils/translate'
import moment from 'moment'
import { formatPrice } from '@/utils/currency'

const presaleQueue=new Queue(getPresale)

function setDate(dom,now,to){
	var duration=moment.duration(to>now?(to-now):0)
	if(!duration.days()&&duration.days()!==0){
		$(dom).find(".day").text('')
	}else{
		$(dom).find(".day").text(paddingZero(Math.floor(duration.asDays())))
	}
	if(!duration.hours()&&duration.hours()!==0){
		$(dom).find(".hour").text('')
	}else{
		$(dom).find(".hour").text(paddingZero(duration.hours()))
	}
	if(!duration.minutes()&&duration.minutes()!==0){
		$(dom).find(".minute").text('')
	}else{
		$(dom).find(".minute").text(paddingZero(duration.minutes()))
	}
	if(!duration.seconds()&&duration.seconds()!==0){
		$(dom).find(".second").text('')
	}else{
		$(dom).find(".second").text(paddingZero(duration.seconds()))
	}
}
manager.add('presale', {
	async created(sku) {
        if(!sku){
            $(this.dom).addClass("state-end")
            return
        }
        this.timeDiff=await fetchTimeDiff()
        this.zoneDiff = getZoneDiff()
        this.data={presaleStatus:2}
        try{
            var data=await presaleQueue.get(sku)
            this.data=data||this.data
        }catch(err){
            //
        }
        // data.skuJdPriceLong //京东价
        // data.earnestLong //定金
        // data.currentPriceLong //预售价
        // data.presaleStartTime; //预售开始时间
        // data.presaleEndTime; //预售结束时间
        // data.presaleStatus //预售状态 0未开始，1预售中，2预售结束，3尾款进行中，4尾款结束
        // data.presaleCount //预约人数
        this.checkoutState()
    },
    async checkoutState(){
        $(this.dom).find('.J_deposit').text(formatPrice(this.data.earnestLong))
        $(this.dom).find('.J_MainPrice').text(formatPrice(this.data.currentPriceLong))
        $(this.dom).find('.J_OriginPrice').text(formatPrice(this.data.skuJdPriceLong))
        $(this.dom).find('.J_ReserveCount').text(translate('$0 people have reserved',this.data.presaleCount||0))
        clearInterval(this.timer)
        if(this.data.presaleStatus==0){
            $(this.dom).removeClass((i,str)=>str.indexOf('state-')>-1).addClass("state-wait")
            const tick=()=>{
                var now=Date.now()+this.timeDiff+this.zoneDiff
                var to=(new Date(this.data.presaleStartTime)).getTime()
                setDate($(this.dom).find(".countdown"),now,to)
                if(now>to){
                    this.data.presaleStatus=1
                    this.checkoutState()
                }
            }
            tick()
            this.timer=setInterval(()=>tick(),1000)
        }
        if(this.data.presaleStatus==1){
            $(this.dom).removeClass((i,str)=>str.indexOf('state-')>-1).addClass("state-saleing")
            const tick=()=>{
                var now=Date.now()+this.timeDiff+this.zoneDiff
                var to=(new Date(this.data.presaleEndTime)).getTime()
                setDate($(this.dom).find(".countdown"),now,to)
                if(now>to){
                    this.data.presaleStatus=2
                    this.checkoutState()
                }
            }
            tick()
            this.timer=setInterval(()=>tick(),1000)
        }
        if(this.data.presaleStatus>1){
            $(this.dom).addClass("state-end")
        }
    },
    destroyed(){
        clearInterval(this.timer)
    }
})
